import { inject } from '@angular/core';
import { SvgIconRegistry } from '@ngneat/svg-icon';

interface SvgIconType {
  name: string;
  data: string;
}

const registered = new Set<string>();

export function registerSvgIcons(...icons: SvgIconType[]): void {
  const registry = inject(SvgIconRegistry);
  const toRegister = icons.filter(i => !registered.has(i.name));
  if (toRegister.length) {
    toRegister.forEach(i => registered.add(i.name));
    registry.register(toRegister);
  }
}
